import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export function slide() {
	window.addEventListener('DOMContentLoaded', function () {
		const splideElements = document.getElementsByClassName('splide');

		for (let i = 0; i < splideElements.length; i++) {
			new Splide(splideElements[i]).mount();
		}

		if (document.querySelector('.js-top-gallery')) {
			new Splide('.js-top-gallery', {
				// type: 'fade',
				type: 'loop',
				perPage: 1,
				// gap: '6.25rem',
				// fixedWidth: '73.75rem',
				arrows: false,
				// rewind: true,
				// breakpoints: {
				// 	768: {
				// 		fixedWidth: '23.125rem',
				// 	},
				// },
				perMove: 1,
				autoplay: true,
				interval: 7000,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				speed: 4000,
				updateOnMove: true,
				pagination: true,
				classes: {
					pagination: 'splide__pagination p-top-gallery__pagination',
					page: 'splide__pagination__page p-top-gallery__page',
				},
			}).mount();
		}

		if (document.querySelector('.js-recruit-gallery')) {
			new Splide('.js-recruit-gallery', {
				// type: 'fade',
				type: 'loop',
				perPage: 1,
				// gap: '6.25rem',
				// fixedWidth: '73.75rem',
				arrows: false,
				// rewind: true,
				// breakpoints: {
				// 	768: {
				// 		fixedWidth: '23.125rem',
				// 	},
				// },
				perMove: 1,
				autoplay: true,
				interval: 7000,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				speed: 4000,
				updateOnMove: true,
				pagination: true,
				classes: {
					pagination: 'splide__pagination p-recruit-gallery__pagination',
					page: 'splide__pagination__page p-recruit-gallery__page',
				},
			}).mount();
		}

		if (document.querySelector('.js-about-infection')) {
			new Splide('.js-about-infection', {
				type: 'loop',
				perPage: 1,
				arrows: false,
				// rewind: true,
				// breakpoints: {
				// 	768: {
				// fixedWidth:'23.125rem',
				// 	},
				// },
				perMove: 1,
				autoplay: true,
				interval: 7000,
				speed: 4000,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				updateOnMove: true,
				pagination: true,
				classes: {
					pagination: 'splide__pagination p-top-infection__pagination',
					page: 'splide__pagination__page p-top-infection__page',
				},
			}).mount();
		}

		if (document.querySelector('.js-service-example')) {
			new Splide('.js-service-example', {
				type: 'loop',
				gap: '1rem',
				perPage: 1,
				fixedWidth: '100%',
				arrows: false,
				autoplay: true,
				interval: 7000,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				speed: 4000,
				classes: {
					pagination: 'splide__pagination c-service-example__pagination',
					page: 'splide__pagination__page c-service-example__page',
				},
			}).mount();
		}

		if (document.querySelector('.js-staff-slide')) {
			new Splide('.js-staff-slide', {
				type: 'loop',
				gap: '4rem',
				perPage: 1,
				fixedWidth: '35rem',
				breakpoints: {
					768: {
						fixedWidth: '25rem',
						gap: '2rem',
					},
				},
				arrows: false,
				autoplay: true,
				interval: 7000,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				speed: 4000,
				classes: {
					pagination: 'splide__pagination p-staff-slide__pagination',
					page: 'splide__pagination__page p-staff-slide__page',
				},
			}).mount();
		}

		const bracesSlideElements = document.querySelectorAll('.js-braces-slide');
		bracesSlideElements.forEach((element) => {
			new Splide(element, {
				// type: 'fade',
				type: 'loop',
				gap: '0',
				perPage: 1,
				fixedWidth: '100%',
				arrows: false,
				// rewind: true,
				perMove: 1,
				autoplay: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				interval: 7000,
				speed: 4000,
				classes: {
					pagination: 'splide__pagination p-braces-appliance__pagination',
					page: 'splide__pagination__page p-braces-appliance__page',
				},
			}).mount();
		});

		const implantsSlideElements = document.querySelectorAll('.js-implants-slide');
		implantsSlideElements.forEach((element) => {
			new Splide(element, {
				type: 'loop',
				gap: '1rem',
				perPage: 1,
				fixedWidth: '100%',
				arrows: false,
				autoplay: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				interval: 7000,
				speed: 4000,
				classes: {
					pagination: 'splide__pagination p-implants-type__pagination',
					page: 'splide__pagination__page p-implants-type__page',
				},
			}).mount();
		});

		const gumCareFlows = document.querySelectorAll('.js-gum-care-flow');
		gumCareFlows.forEach((flow) => {
			new Splide(flow, {
				type: 'loop',
				perPage: 3,
				breakpoints: {
					1440: {},
					768: { perPage: 1 },
				},
				arrows: false,
				autoplay: true,
				pauseOnHover: false,
				pauseOnFocus: false,
				focus: 'center',
				interval: 7000,
				speed: 4000,
			}).mount();
		});

		// 縦方向のスクロールを許可するためのイベントリスナーを追加
		const slides = document.querySelectorAll('.splide__slide');
		slides.forEach((slide) => {
			slide.addEventListener('touchstart', function (e) {
				e.stopPropagation();
			});
		});
	});
}
